import { GetFromScript } from "./script-data.service"

const settings = GetFromScript("store-settings");

export class Currency {
    constructor({ id, cultureName, code }) {
        this.id = id;
        this.culture = cultureName;
        this.currencyCode = code;
    }

    format(number) {
        let options = {
            style: "currency",
            currency: this.currencyCode,
            currencyDisplay: "narrowSymbol"
        };

        let formatter = new Intl.NumberFormat(this.culture, options);
        return formatter.format(number);
    }
}

export const {
    storeId: StoreId,
    displayPricesWithTax: DisplayPricesWithTax
} = settings;

export const StoreCurrency = new Currency(settings.storeCurrency);

export default {
    StoreId,
    StoreCurrency,
    DisplayPricesWithTax
}